import { render } from "./BackgroundCustomizer.vue?vue&type=template&id=499de266"
import script from "./BackgroundCustomizer.vue?vue&type=script&lang=js"
export * from "./BackgroundCustomizer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__